(() => {
  const ACTIVE_CLASS = 'is-active';

  function getDrawerFromTrigger(trigger) {
    const id = trigger?.dataset?.sizeChartDrawerTarget;
    if (!id) return null;
    return document.getElementById(id);
  }

  function openDrawer(drawer, trigger) {
    if (!drawer) return;

    const url = trigger?.dataset?.sizeChartUrl || '';
    const label = trigger?.dataset?.sizeChartLabel || '';

    const titleEl = drawer.querySelector('.size-chart-drawer__title');
    const iframe = drawer.querySelector('.size-chart-drawer__iframe');

    if (titleEl) titleEl.textContent = label;
    if (iframe) {
      iframe.setAttribute('title', label);
      if (url) iframe.setAttribute('src', url);
    }

    drawer.dataset.triggerId = trigger?.id || '';
    drawer.classList.add(ACTIVE_CLASS);
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('overflow-hidden');

    const panel = drawer.querySelector('.size-chart-drawer__panel');
    panel?.focus?.();
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove(ACTIVE_CLASS);
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');

    const iframe = drawer.querySelector('.size-chart-drawer__iframe');
    // Stop PDF/video playback + avoid background network activity
    if (iframe) iframe.removeAttribute('src');

    const triggerId = drawer.dataset.triggerId;
    if (triggerId) document.getElementById(triggerId)?.focus?.();
    delete drawer.dataset.triggerId;
  }

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-size-chart-drawer-open]');
    if (openBtn) {
      event.preventDefault();
      openDrawer(getDrawerFromTrigger(openBtn), openBtn);
      return;
    }

    const closeBtn = event.target.closest('[data-size-chart-drawer-close]');
    if (closeBtn) {
      const drawer = closeBtn.closest('.size-chart-drawer');
      closeDrawer(drawer);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openDrawerEl = document.querySelector(`.size-chart-drawer.${ACTIVE_CLASS}`);
    if (openDrawerEl) closeDrawer(openDrawerEl);
  });
})();

